import { Image, message } from "antd";
import { useRef } from "react";
import { mimeTypesToText } from "../mocks/mimeTypes";
import { typeFiles } from "../mocks/typeFiles";

const useUploadFile = ({ fileList, setFileList, justImages, maxCount, maxSizeInBytes, multipleFiles, acceptFilesFormat }) => {

    const uploadElementRef = useRef(null)
    const acceptFiles = justImages ? 'image/jpg, image/jpeg,image/png' : acceptFilesFormat ? acceptFilesFormat : 'image/jpg, image/jpeg,image/png, application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint'

    const getFileSize = (size, fixed = 2) => {
        if ((size / 1024) < 1000) return `${(size / 1024).toFixed(fixed)}KB`
        return `${(size / 1024 / 1024).toFixed(fixed)}MB`
    }

    const acceptFilesText = mimeTypesToText(acceptFiles)
    const handleOnChange = (event) => {

        let newFiles = event?.target?.files ? Array.from(event?.target?.files) : event?.fileList ? event?.fileList.map((item) => ({ ...item, title: item?.title ? item.title : item.name, description: item?.description ? item.description : 'Descipción de la imagen' })) : undefined
        if(!newFiles) return
        if ((fileList.length === maxCount) || (!event?.target?.files && event.fileList.length > maxCount) || (event?.target?.files && newFiles.length + fileList.length > maxCount)) return message.error('La cantidad de archivos es igual o mayor a la permitida')
        newFiles = [...newFiles].filter((file) => {
            if (file.size > maxSizeInBytes) {
                message.error(`El archivo ${file.name} pesa más de ${getFileSize(maxSizeInBytes, 0)}`)
                return false
            }
            if (!acceptFiles.includes(file.type)) {
                message.error(`El archivo ${file.name} no tiene un formato permitido`)
                return false
            }
            return true
        })
        if (event?.target?.files) {
            newFiles = newFiles?.map((file) => ({
                uid: crypto.randomUUID(),
                title: file.name,
                description: 'Descripcion de la imágen',
                name: file.name,
                status: 'done',
                size: file.size,
                type: file.type,
                originFileObj: file,
                lastModified: file.lastModified,
                lastModifiedDate: file.lastModifiedDate
            }))
        }
        if (multipleFiles) {
            return event?.target?.files ? setFileList((prev) => [...prev, ...newFiles]) : setFileList(newFiles)
        }
        setFileList([newFiles.at(-1)])
        uploadElementRef.current.value = ''
    }

    const handleRemoveFile = (file) => () => {
        setFileList((prev) => {
            const previousFiles = [...prev]
            return previousFiles.filter((prevFile) => prevFile.uid !== file.uid)
        })
        uploadElementRef.current.value = ''
    }

    const handleOpenDialogFile = () => {
        uploadElementRef.current.click();
    }

    //Funcion para poder modificar el texto y descripción de una imagen
    const handleTextChange = ({ id, type, value }) => {
        setFileList((prevList) => {
            const newList = [...prevList]
            return newList.map((file) => {
                if (file.uid === id) {
                    return { ...file, [type]: value }
                }
                return file;
            })
        })
    }

    //Funcion para renderizar el icono del archivo subido, o una imagen si el tipo de archivo coincide 
    const itemRender = (file) => {
        if (file.type.startsWith('image/')) {
            return (
                <Image
                    className='uploaded-file__image'
                    src={URL.createObjectURL(file.originFileObj)}
                    alt={file.name}
                />
            )
        }
        const fileExtension = file.name.split('.').pop().toLowerCase();
        return typeFiles[fileExtension] || typeFiles.default
    }
    return (
        {
            uploadElementRef,
            acceptFiles,
            acceptFilesText,
            getFileSize,
            handleOnChange,
            handleOpenDialogFile,
            handleRemoveFile,
            handleTextChange,
            itemRender
        }
    )
}

export default useUploadFile